import {connect} from "react-redux";
import {
    getDataTable,
    getDataTableForRegularPrices,
    setActivePromotionsScreen,
    setPreloader
} from "../../Redux/content-reducer";
import {SecondRowInHeader} from "./SecondRowInHeader";



let mapStateToProps = (state) => {
    return {
        data: state
    }
};

let mapDispatchToProps = {getDataTable, getDataTableForRegularPrices, setPreloader, setActivePromotionsScreen};


export default connect(mapStateToProps, mapDispatchToProps)(SecondRowInHeader);